import { render, staticRenderFns } from "./DashboardTourCalendar.vue?vue&type=template&id=390cd2ad&scoped=true&"
import script from "./DashboardTourCalendar.vue?vue&type=script&lang=ts&"
export * from "./DashboardTourCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardTourCalendar.vue?vue&type=style&index=0&id=390cd2ad&scoped=true&lang=sass&"
import style1 from "./DashboardTourCalendar.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390cd2ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText,VCardTitle})
